export default {
  metamask_address: ""
};
